import '.a{display:flex;}.ssr-plugin'
import '.b{flex-direction:column;}.ssr-plugin'
import '.ce{align-items:flex-start;}.ssr-plugin'
import '.f{gap:1.5rem;}.ssr-plugin'
import '.d7{background:var(--shades-white);}.ssr-plugin'
import '.aa{flex-direction:row;}.ssr-plugin'
import '.ck{justify-content:flex-start;}.ssr-plugin'
import '.iz{gap:2.5rem;}.ssr-plugin'
import '.dv{flex-wrap:wrap;}.ssr-plugin'
import '.c{align-items:center;}.ssr-plugin'
import '.an{gap:0.5rem;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { Title } from '@app/components/core/typography/Title'
import { Text } from '@app/components/core/typography/Text'

export interface NutshellItem {
  total: string | number
  subtitle: string
}

export interface NutshellProps {
  heading: string
  items: NutshellItem[]
  style?: Style
}

export const Nutshell = ({ heading, items, style }: NutshellProps) => {
  return (
    <styled.div className="a b ce f d7"
      data-testid="nutshell"
      style={{
        ...style,
      }}
    >
      {/* Heading */}
      <Title.H4
        style={{
          color: 'var(--primary-blue)',
          textAlign: 'center',
          margin: 0,
        }}
      >
        {heading}
      </Title.H4>

      {/* Data Points Container */}
      <div className="a aa ck ce iz dv"
      >
        {items.map((item, index) => (
          <div className="a b c an"
            key={index}
          >
            {/* Total Number */}
            <Title.H1
              style={{
                fontSize: '4rem',
                fontWeight: '700',
                lineHeight: '100%',
                margin: 0,
                color: 'var(--primary-blue)',
                fontFamily: 'FunnelDisplay',
              }}
            >
              {item.total}
            </Title.H1>

            {/* Subtitle */}
            <Text.Medium
              style={{
                color: 'var(--primary-blue)',
                opacity: 0.6,
                margin: 0,
                textAlign: 'center',
              }}
            >
              {item.subtitle}
            </Text.Medium>
          </div>
        ))}
      </div>
    </styled.div>
  )
}
